<template>
  <div v-show="!isLoading" class="transition-all duration-500">
    <Common left-menu><slot /></Common>
  </div>
</template>

<script setup>
import Common from '@/layouts/Common.vue';

const nuxtApp = useNuxtApp();
const isLoading = ref(true);
nuxtApp.hook('page:start', () => {
  isLoading.value = true;
});
nuxtApp.hook('page:finish', () => {
  isLoading.value = false;
});
</script>
